import sanitizeHtml from 'sanitize-html';

sanitizeHtml.defaults.allowedAttributes['div'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['span'] = ['class'];

// Allow table elements and their common attributes
sanitizeHtml.defaults.allowedTags = [
    ...sanitizeHtml.defaults.allowedTags,
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'caption',
    'colgroup',
    'col',
];

sanitizeHtml.defaults.allowedAttributes['table'] = [
    'class',
    'border',
    'cellpadding',
    'cellspacing',
    'width',
    'height',
];
sanitizeHtml.defaults.allowedAttributes['thead'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['tbody'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['tfoot'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['tr'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['th'] = [
    'class',
    'scope',
    'colspan',
    'rowspan',
    'headers',
    'id',
    'width',
    'height',
    'align',
    'style',
    'valign',
];
sanitizeHtml.defaults.allowedAttributes['td'] = [
    'class',
    'colspan',
    'rowspan',
    'headers',
    'width',
    'height',
    'align',
    'style',
    'valign',
];
sanitizeHtml.defaults.allowedAttributes['caption'] = ['class'];
sanitizeHtml.defaults.allowedAttributes['col'] = ['class', 'span'];
sanitizeHtml.defaults.allowedAttributes['colgroup'] = ['class', 'span'];

// Allow all inline styles for table elements
sanitizeHtml.defaults.allowedStyles = {
    '*': {
        'text-align': [/.*/],
        'vertical-align': [/.*/],
        color: [/.*/],
        'background-color': [/.*/],
        width: [/.*/],
        height: [/.*/],
        padding: [/.*/],
        margin: [/.*/],
        border: [/.*/],
        'font-weight': [/.*/],
        'font-size': [/.*/],
    },
};

export default sanitizeHtml.defaults;
